type MarginMapping = {
  leftMarginMapping: number;
  rightMarginMapping: number;
  topMarginMapping?: number;
};

const leftMarginMappings: Record<string, (width: number) => MarginMapping> = {
  schuifdeurschuifdeurpaneelpaneel: (width: number) => ({
    leftMarginMapping: width >= 1650 ? -0.054 : -0.047,
    rightMarginMapping: -0.022,
    topMarginMapping: -0.01,
  }),

  dubbeleschuifdeur: (width: number) => ({
    leftMarginMapping: -0.1,
    rightMarginMapping: 0.01,
  }),
  dubbel2paneel: (width: number) => ({
    // 1650 > width different mapping
    leftMarginMapping: width >= 1650 ? -0.043 : -0.035,
    rightMarginMapping: -0.022,
    topMarginMapping: -0.01,
  }),
  taatsdeurtaatsdeurpaneelpaneel: (width: number) => ({
    // 1650 > width different mapping
    leftMarginMapping: width >= 1650 ? -0.0535 : -0.045,
    rightMarginMapping: -0.022,
    topMarginMapping: -0.01,
  }),

  schuifdeurpaneelpaneelschuifdeur: (width: number) => ({
    leftMarginMapping: width >= 1650 ? -0.06 : -0.054,
    rightMarginMapping: -0.0365,
  }),
  paneelpaneelpaneelpaneel: (width: number) => ({
    leftMarginMapping: -0.045,
    rightMarginMapping: -0.022,
  }),
  paneelpaneelpaneel: (width: number) => ({
    leftMarginMapping: width >= 1650 ? -0.17 : -0.158,
    rightMarginMapping: -0.022,
    // topMarginMapping: -0.01,
  }),
};

export const getMarginMapping = (
  doorCode: string,
  width: number,
): MarginMapping => {
  const mappingFn = leftMarginMappings[doorCode];
  if (mappingFn) {
    return mappingFn(width);
  }
  return {
    leftMarginMapping: -0.05,
    rightMarginMapping: -0.022,
    topMarginMapping: 0,
  };
};
